module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0108.jpg?v=ca34ac15";